<template>
	<!-- begin sidebar nav -->
	<div class="menu" v-if="menus">
		<div class="menu-search mb-n3" v-if="appOptions.appSidebarSearch">
			<input type="text" v-on:keyup="handleSidebarFilter" class="form-control" placeholder="Sidebar menu filter..." />
		</div>
		<div class="menu-header">Menú</div>
		<template v-for="menu in menus">
			<sidebar-nav-list 
				ref="sidebarNavList" 
				v-bind:menu="menu" 
				v-bind:scrollTop="scrollTop" 
				v-bind:key="menu.path" 
				v-bind:status="menu.status" 
				v-on:collapse-other="handleCollapseOther(menu)"
				v-on:show-float-submenu="handleShowFloatSubmenu"
				v-on:hide-float-submenu="handleHideFloatSubmenu"></sidebar-nav-list>
		</template>
		
		<!-- BEGIN minify-button -->
		<div class="menu-item d-flex">
			<a href="javascript:;" class="app-sidebar-minify-btn ms-auto" v-on:click="handleSidebarMinify()"><i class="fa fa-angle-double-left"></i></a>
		</div>
		<!-- END minify-button -->
	</div>
	<!-- end sidebar nav -->
</template>

<script>
//import SidebarMenu from './SidebarMenu.vue'
import SidebarNavList from './SidebarNavList.vue'
import AppOptions from '../../config/AppOptions.vue'

export default {
	beforeCreate() {
		var userSetting = localStorage.getItem('userSettings');
		if(userSetting != undefined){
			//console.log(JSON.parse(userSetting));
			this.pageUserSettings = JSON.parse(userSetting);
		}else{
				this.$router.push('/login');
		}
	},
	name: 'SidebarNav',
	props: ['scrollTop'],
	components: {
		SidebarNavList
	},
	data () {
		return { 
			menus: {},
			appOptions: AppOptions
		}
	},
	mounted: function () {
		this.createMenu();
	},
	methods: {
		createMenu(){
			
var sidebarMenuArray = [];

  var userSetting = localStorage.getItem("userSettings");

  if(userSetting != null){
    //   debugger; // eslint-disable-line no-debugger

      var pageUserSettings = JSON.parse(userSetting);
       console.log(pageUserSettings);
      var permisos = pageUserSettings.Permisos;
      //  console.log(JSON.stringify(permisos));

      sidebarMenuArray = [];


      for (var n1 = 0; n1 < permisos.length; n1++) {
              var path = permisos[n1].Path;
              var level1 = {
                path: "/"+path,
                icon: "fa fa-list-ol",
                title: permisos[n1].Descripcion
              };

              if(permisos[n1].Descripcion == "Tanques"){
                level1.icon = "fa fa-gas-pump";
              }else{
                level1.children = [];
                for (var n2 = 0; n2 < permisos[n1].Submodulos.length; n2++){
                            var subpath = permisos[n1].Submodulos[n2].Path;
                            var suboption = {
                              path: "/" + subpath,
                              title: permisos[n1].Submodulos[n2].Descripcion,
                              children: [],
                            };
                            for (var n3 = 0; n3 < permisos[n1].Submodulos[n2].Permisos.length; n3++){
                                      var thirdpath = permisos[n1].Submodulos[n2].Permisos[n3].Path;
                                      var thirdoption = {
                                        path: "/" + thirdpath,
                                        title: permisos[n1].Submodulos[n2].Permisos[n3].Descripcion,
                                        // children: [],
                                      };
                                      suboption.children.push(thirdoption);
                                      
                                      console.log(permisos[n1].Submodulos[n2].Permisos[n3].Path)
                            }

                  
                  level1.children.push(suboption);
                }

              }

        sidebarMenuArray.push(level1);
      }




  }










//console.log(JSON.stringify(sidebarMenuArray) );

			this.menus = sidebarMenuArray;
		},
		handleShowFloatSubmenu: function(menu, offset) {
			this.$emit('show-float-submenu', menu, offset);
		},
		handleHideFloatSubmenu: function() {
			this.$emit('hide-float-submenu');
		},
		handleCollapseOther: function(menu) {
			for (var i = 0; i < this.menus.length; i++) {
				this.$refs.sidebarNavList[i].collapse(menu);
			}
		},
		handleSidebarMinify: function() {
			this.appOptions.appSidebarMinified = !this.appOptions.appSidebarMinified;
		},
		handleSidebarFilter: function(e) {
			var value = e.target.value;
					value = value.toLowerCase();
			
			if (value) {
				for (var x = 0; x < this.menus.length; x++) {
					var title = (this.menus[x].title).toLowerCase();
					var children = this.menus[x].children;
				
					if (title.search(value) > -1) {
						this.$refs.sidebarNavList[x].show();
						
						if (children) {
							this.$refs.sidebarNavList[x].searchExpand();
						}
					} else {
						if (children) {
							var hasActive = false;
							for (var y = 0; y < children.length; y++) {
								var title2 = (children[y].title).toLowerCase();
							
								if (title2.search(value) > -1) {
									hasActive = true;
									this.$refs.sidebarNavList[x].$refs.sidebarNavList[y].show();
									this.$refs.sidebarNavList[x].searchExpand();
								} else {
									if (hasActive) {
										this.$refs.sidebarNavList[x].searchExpand();
									} else {
										this.$refs.sidebarNavList[x].hide();
									}
									this.$refs.sidebarNavList[x].$refs.sidebarNavList[y].hide();
								}
							}
						} else {
							this.$refs.sidebarNavList[x].hide();
						}
					}
				} 
			} else {
				for (var a = 0; a < this.menus.length; a++) {
					this.$refs.sidebarNavList[a].show();
					
					var submenu = this.menus[a].children;
					if (submenu) {
						for (var b = 0; b < submenu.length; b++) {
							this.$refs.sidebarNavList[a].$refs.sidebarNavList[b].show();
						}
					}
				}
			}
			console.log('------');
		}
	}
}
</script>
